import { ContactUsAlert } from "Components/Form/Alert";
import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { Select } from "Components/Form/Select";
import { useTexts } from "Components/TextContext";
import { AlertTitle } from "Components/TextContext/commonComponentEnums";
import { ErrorPrefix } from "Constants/constants";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { TextLanguage } from "Store/texts/interfaces";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { InsuranceOwnerFormValues } from "./interfaces";
import { getRelationOptions } from "./utils";

interface Props {
  formProps: FormikProps<InsuranceOwnerFormValues>;
  formText: any;
  lang: TextLanguage;
}
const InsuranceOwnerFormElements = ({
  formProps,
  formText,
  lang,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  const relationError = formProps.errors.relation;

  return (
    <>
      <RadioButtonTrueFalse
        name="insuranceHolderIsOwner"
        id="insuranceHolderIsOwner"
        hint={formText.insuranceHolderIsOwner.hint[lang]}
        label={formText.insuranceHolderIsOwner.label[lang]}
        options={[
          {
            label: formText.insuranceHolderIsOwner.options.yes[lang],
            value: true,
            id: "insuranceHolderIsOwner-yes",
          },
          {
            label: formText.insuranceHolderIsOwner.options.no[lang],
            value: false,
            id: "insuranceHolderIsOwner-no",
          },
        ]}
        direction="vertical"
        error={getError("insuranceHolderIsOwner", formProps)}
      />
      {formProps.values.insuranceHolderIsOwner === BooleanFormType.FALSE && (
        <>
          <Select
            large
            id="relation"
            name="relation"
            label={formText.relation.label[lang]}
            options={getRelationOptions(getText)}
            error={getError("relation", formProps)}
          />
          {relationError && relationError.startsWith(ErrorPrefix.BREAKING) && (
            <ContactUsAlert
              title={getText(AlertTitle.CALL_US)}
              description={getText(
                "insuranceownerform.alertdescription.ownercantbuy",
              )}
              alertId="invalidVehicleOwner"
              variant="border"
              marginBottom="32px"
            />
          )}
          <Input
            id="age"
            name="age"
            type="number"
            label={formText.age.label[lang]}
            hint={formText.age.hint[lang]}
            error={getError("age", formProps)}
            inputMode={InputMode.NUMERIC}
          />
        </>
      )}
    </>
  );
};

export default InsuranceOwnerFormElements;
